import { render, staticRenderFns } from "./race-selector.vue?vue&type=template&id=96e8e7d0"
import script from "./race-selector.vue?vue&type=script&lang=js"
export * from "./race-selector.vue?vue&type=script&lang=js"
import style0 from "./race-selector.vue?vue&type=style&index=0&id=96e8e7d0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports